(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('NewLibraryCtrl', newLibraryCtrl);

    function newLibraryCtrl($scope, $mdDialog, libraryTypeString) {
        $scope.libraryName = 'My library';
        $scope.colorMode = 'rgb';
        $scope.libraryTypeString = libraryTypeString;

        $scope.createLibrary = function () {
            $mdDialog.hide({
                name: $scope.libraryName,
                colorMode: $scope.colorMode
            });
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();
